import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Ag1TitleComponent } from '../../core/components/ag1-title/ag1-title.component';
import { ShimmerLoaderComponent } from '../shimmer-loader/shimmer-loader.component';

@Component({
  selector: 'ag-page-loading-placeholder',
  templateUrl: './page-loading-placeholder.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Ag1TitleComponent, ShimmerLoaderComponent],
})
export class PageLoadingPlaceholderComponent {
  @Input()
  title: string;
}
